<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'base.settings' | translate }}
    v-card-content
      v-input-r(
        ref="firstNameInput"
        :label="$t('base.first_name')"
        :hint="errorMessage('first_name')"
        :invalid="!!errorMessage('first_name')"
        :pattern="'.{1,30}'"
        v-model="user.first_name"
        @blur="validateFirstName")
      v-input-r(
        ref="lastNameInput"
        :label="$t('base.last_name')"
        :hint="errorMessage('last_name')"
        :invalid="!!errorMessage('last_name')"
        :pattern="'.{1,30}'"
        v-model="user.last_name"
        @blur="validateLastName")
      v-input-r(
        ref="phoneInput"
        :label="$t('base.phone')"
        :hint="errorMessage('phone')"
        :invalid="!!errorMessage('phone')"
        :pattern="'.{1,15}'"
        v-model="user.phone"
        @blur="validatePhone")
      v-input-r(
        :label="$t('base.about_me')"
        v-model="user.profile.about")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="saveChanges") {{ 'base.save' | translate }}
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'SettingsUserModal',

  data: () => ({
    user: {
      first_name: '',
      last_name: '',
      phone: '',
      profile: {
        about: '',
        // language: null
      }
    },
    errors: {
      first_name: null,
      last_name: null,
      phone: null
    },
    langs: [
      { id: 0, name: 'Українська', key: 'uk' },
      { id: 1, name: 'Русский', key: 'ru' },
      { id: 2, name: 'Polski', key: 'pl' },
      { id: 3, name: 'English', key: 'en' },
      { id: 4, name: 'Eesti', key: 'et' },
      { id: 5, name: 'Ελληνικά', key: 'el' },
      { id: 6, name: 'Español', key: 'es' },
      { id: 7, name: 'Español (US)', key: 'es-us' },
      { id: 8, name: 'Netherlands', key: 'nl' },
      { id: 9, name: 'Deutsch', key: 'de' },
      { id: 10, name: 'Français', key: 'fr' },
      { id: 11, name: 'Italiano', key: 'it' },
      { id: 12, name: 'Română', key: 'ro' },
      { id: 13, name: 'USA', key: 'us' },
    ],
    loading: false
  }),

  mixins: [formErrorsMixin],

  watch: {
    'user.first_name' (newValue) {
      if (this.errors.first_name && newValue && newValue.length > 0 && newValue.length <= 30) {
        this.errors.first_name = null
      }
    },
    'user.last_name' (newValue) {
      if (this.errors.last_name && newValue && newValue.length > 0 && newValue.length <= 30) {
        this.errors.last_name = null
      }
    },
    'user.phone' (newValue) {
      if (this.errors.phone && newValue && newValue.length > 0 && newValue.length <= 15) {
        this.errors.phone = null
      }
    }
  },

  mounted () {
    this.loadData()
  },

  methods: {
    async loadData () {
      const { data } = await api.account.get()
      const {
        first_name: firstName,
        last_name: lastName,
        phone,
        profile
      } = data
      this.user.first_name = firstName
      this.user.last_name = lastName
      this.user.phone = phone
      this.user.profile.about = profile.about
    },

    validateFirstName () {
      this.errors.first_name = null
      if (!this.user.first_name) {
        this.errors.first_name = ['3']
      } else if (this.user.first_name.length > 30) {
        this.errors.first_name = ['6', 30]
      }
    },

    validateLastName () {
      this.errors.last_name = null
      if (!this.user.last_name) {
        this.errors.last_name = ['3']
      } else if (this.user.last_name.length > 30) {
        this.errors.last_name = ['6', 30]
      }
    },

    validatePhone () {
      this.errors.phone = null
      if (!this.user.phone) {
        this.errors.phone = ['3']
      } else if (this.user.phone.length > 15) {
        this.errors.phone = ['6', 15]
      }
    },

    forceValidation () {
      this.validateFirstName()
      this.validateLastName()
      this.validatePhone()

      if (this.$refs.firstNameInput) {
        this.$refs.firstNameInput.hasBlurred = true
      }
      if (this.$refs.lastNameInput) {
        this.$refs.lastNameInput.hasBlurred = true
      }
      if (this.$refs.phoneInput) {
        this.$refs.phoneInput.hasBlurred = true
      }
    },

    async saveChanges () {
      this.forceValidation()

      if (this.errors.first_name !== null || this.errors.last_name !== null || this.errors.phone !== null) {
        return
      }

      this.loading = true
      const payload = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        phone: this.user.phone,
        profile: {
          about: this.user.profile.about,
        }
      }

      const { errors } = await api.account.update(payload)
      this.loading = false

      if (!errors) {
        this.$toasted.show(this.$t('info.changed'))
        this.$emit('close')
      } else {
        this.$toasted.error(this.$t('errors.unexpected'))
        this.errors = errors
      }
    },

    checkValidData () {
      this.validateFirstName()
      this.validateLastName()
      this.validatePhone()
    },

    onLangChange ({ key }) {
      this.$store.dispatch('account/setLang', key)
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>